// extracted by mini-css-extract-plugin
export default {"component":"_5m2DC"};